interface RuntimeWindow extends Window {
  BOC_API_BASE?: string;
}

declare const __BOC_API_BASE__: string | undefined;
declare const __FEATURE_PATTERN_LIBRARY_V2__: boolean | undefined;
declare const __BOC_ENABLE_MOCKS__: boolean | undefined;
declare const __JOURNAL_V2_UI__: boolean | undefined;
declare const __PORTFOLIO_BOOKS_UI__: boolean | undefined;
declare const __JOURNAL_SAMPLE_DATA__: boolean | undefined;

export const DEFAULT_API_BASE = 'https://bocapital-dashboard-312264840660.europe-west1.run.app';

const BUILD_API_BASE = (
  String(typeof __BOC_API_BASE__ === 'string' ? __BOC_API_BASE__ : '').trim().replace(/\/$/, '')
) || DEFAULT_API_BASE;

function isLocalhostHost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function resolveApiBase(): string {
  if (typeof window === 'undefined') return '';

  const win = window as RuntimeWindow;
  const configured = String(win.BOC_API_BASE || '').trim().replace(/\/$/, '');
  if (configured) {
    if (window.location.protocol === 'capacitor:') {
      try {
        const parsed = new URL(configured);
        if (isLocalhostHost(parsed.hostname)) {
          return BUILD_API_BASE;
        }
      } catch {
        // Keep malformed configured URL behavior unchanged so network errors stay visible.
      }
    }
    return configured;
  }

  if (window.location.protocol === 'capacitor:') {
    return BUILD_API_BASE;
  }

  return BUILD_API_BASE || window.location.origin;
}

export function isPatternLibraryV2Enabled(): boolean {
  return Boolean(__FEATURE_PATTERN_LIBRARY_V2__ ?? true);
}

export function isMockDataEnabled(): boolean {
  return Boolean(__BOC_ENABLE_MOCKS__ ?? false);
}

/** Phase 2 E6: the rebuilt journal UI is off unless the build sets JOURNAL_V2_UI=true. */
export function isJournalV2UiEnabled(): boolean {
  return Boolean(typeof __JOURNAL_V2_UI__ === 'boolean' ? __JOURNAL_V2_UI__ : false);
}

/** Phase 2 WP5 (E8): journal pages show upstream's recorded demo dataset, labelled as
 * sample data. Build-time only (JOURNAL_SAMPLE_DATA=true with JOURNAL_V2_UI=true), for
 * parity checks; a normal build leaves both the switch and the recording out. */
export function isJournalSampleDataEnabled(): boolean {
  return Boolean(typeof __JOURNAL_SAMPLE_DATA__ === 'boolean' ? __JOURNAL_SAMPLE_DATA__ : false);
}


/** Portfolio books page: off unless the build sets PORTFOLIO_BOOKS_UI=true. The
 * API answers 503 until PORTFOLIO_BOOKS_ENABLED anyway; this keeps the nav item
 * and route out of the shell until the operator turns the books on. */
export function isPortfolioBooksUiEnabled(): boolean {
  return Boolean(typeof __PORTFOLIO_BOOKS_UI__ === 'boolean' ? __PORTFOLIO_BOOKS_UI__ : false);
}
